import { buttonVariants } from "@anthra/ui/button-variants"
import { type QueryClient } from "@tanstack/react-query"
import { createRootRouteWithContext, Link, Outlet } from "@tanstack/react-router"

/**
 * The root route. Everything renders inside this Outlet.
 *
 * `createRootRouteWithContext` types the router context, so `queryClient` is
 * available and typed in every route below.
 */
export const Route = createRootRouteWithContext<{ queryClient: QueryClient }>()({
	component: RootLayout,
	notFoundComponent: NotFound,
})

function RootLayout() {
	return <Outlet />
}

function NotFound() {
	return (
		<main className="mx-auto flex min-h-screen max-w-lg flex-col items-center justify-center gap-4 p-6 text-center">
			<h1 className="text-section-title text-foreground">Page not found</h1>
			<p className="text-muted text-description">
				That link does not point anywhere in Swamithra any more.
			</p>
			<Link
				to="/home"
				className={buttonVariants({ variant: "secondary" })}
			>
				Go to Home
			</Link>
		</main>
	)
}
